import * as React from 'react';

const ScanCheckSvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg viewBox="0 0 24 24" {...props}>
        <path d="M15.3 9.5L11 13.8l-2.3-2.3-.7.7 3 2.8 5-4.8zM2 8h1V3h5V2H2zM16 2v1h5v5h1V2zM21 21h-5v1h6v-6h-1zM3 16H2v6h6v-1H3z" />
    </svg>
);

ScanCheckSvg.displayName = 'ScanCheckSvg';
export default ScanCheckSvg;
